import React, { useState, useCallback, useEffect, useContext} from 'react';
import StartButton from '../buttons/StartButton.jsx';
import VocabMultipleChoice from './VocabMC';
import { StructuredSentence } from './StructuredSentence';
import GameSummary from './GameSummary.jsx';
import VocabChoiceModal from '../buttons/VocabChoiceModal.jsx';
import { GameContext } from '../../GameContext';
import { API_URL } from '../../config';
import { useAuth } from "react-oidc-context";

const Vocabulary = () => {
  const auth = useAuth();
  const token = auth.user?.access_token;
  const [gameKey, setGameKey] = useState(0);
  const [isGameActive, setIsGameActive] = useState(false);
  const [isAnswerSelected, setIsAnswerSelected] = useState(false);
  const [structuredResult, setStructuredResult] = useState([]);
  const [gameResult, setGameResult] = useState(null);
  const [listCategoryChoices, setListCategoryChoices] = useState([]);
  const [listLevelChoices, setListLevelChoices] = useState([]);
  const { selectedLanguage, triggerGameEnd, onGameEndComplete, setGameActiveStatus, flagImageUrl, resultsWord, languageData, learnedWords, updateLearnedList, loadLanguageData } = useContext(GameContext);
  const handleResultFromMultipleChoice = useCallback((result) => {
    console.log("HandleResult process running...");
      setStructuredResult(result);
  }, []);

  const endGame = useCallback(async () => {
    console.log("Ending the game process");
    
    try {
      console.log('Api url - ', API_URL)
      console.log(selectedLanguage)
      console.log(learnedWords)
      const response = await fetch(`${API_URL}/api/end_vocab_mc`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          learned_words: learnedWords,
          vocab_list: languageData
        }),
      });
      if (!response.ok) {
        throw new Error('Failed to end game on server');
      }
      const data = await response.json();
      console.log("Game ended on server:", data);
      let updatedList = data.learnedWordList;
      if (!Array.isArray(updatedList)) {
        console.log("Converting fake array back to real array");
        updatedList = Object.values(updatedList);
      }
      updateLearnedList(updatedList);

      console.log(selectedLanguage)
      setGameResult({
        isEnded: true,
        summary: data.summary && typeof data.summary === 'object' ? data.summary : null
      });

    } catch (error) {
      console.error("Error ending game on server:", error);
      setGameResult({ isEnded: true, summary: null });
    } finally {
      setIsGameActive(false);
      setGameActiveStatus(false);
    }
  }, [setGameActiveStatus, learnedWords]);

  const handleGameStart = useCallback(async(started) => {
    if (started) {
      console.log("Starting the game process");
      console.log(selectedLanguage)
      setIsGameActive(true);
      setGameActiveStatus(true);
      setGameKey(prevKey => prevKey + 1);
      setIsAnswerSelected(false);
      setGameResult(null);
    } else {
      await endGame();
    }
  }, [endGame, setGameActiveStatus]);

  useEffect(() => {
    if (triggerGameEnd && isGameActive) {
      endGame();
      onGameEndComplete();
    }
  }, [triggerGameEnd, isGameActive, endGame, onGameEndComplete, learnedWords]);

  useEffect(() => {
    if (isGameActive) {
      console.log("Language changed while game was active. Resetting game state.");
      setIsGameActive(false);
      setGameActiveStatus(false);
      setGameResult(null);
      endGame();
    }
  }, [selectedLanguage, setGameActiveStatus]);

  const nextWord = useCallback(() => {
    console.log("Moving to next word");
    setGameKey(prevKey => prevKey + 1);
    setIsAnswerSelected(false);
  }, []);

  const handleAnswerSelected = useCallback((selected) => {
    console.log("Handling Answer...");
    setIsAnswerSelected(selected);
  }, []);
  
  // Get word list choices
    useEffect(() => {
      const fetchWordListChoices = async () => {
        try {
          console.log('Api url - ', API_URL);
          console.log(selectedLanguage);
          console.log('fetching word list choices')
          const response = await fetch(`${API_URL}/api/get-word-list-choices`, {
            method: 'POST',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
          });
          const data = await response.json();
          setListCategoryChoices(data.categories);
          setListLevelChoices(data.levels);
          console.log('Categories: ', data.categories);
        } catch (error) {
          console.error('Error fetching word list choices:', error);
        }
      };
      fetchWordListChoices();
    }, [selectedLanguage]);

  const handleWordListSave = async ({selectedList1, selectedList2, otherSelected1, otherSelected2}) => {
    console.log('Selected List 1:', selectedList1);
    console.log('Selected List 2:', selectedList2);
    try {
      console.log('Api url - ', API_URL)
      console.log(selectedLanguage)
      const response = await fetch(`${API_URL}/api/update-word-list`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ selectedList1, selectedList2, otherSelected1, otherSelected2, languageData, learnedWords }),
      });
      
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      
      const data = await response.json();
      let updatedList = data.learned_words;
      if (!Array.isArray(updatedList)) {
        console.log("Converting fake array back to real array");
        updatedList = Object.values(updatedList);
      }
      updateLearnedList(updatedList);
      loadLanguageData(data.vocab_words)

      console.log('Save result:', data);
      // Handle successful save (e.g., show a success message)
    } catch (error) {
      console.error('Error saving choices:', error);
      // Handle error (e.g., show an error message to the user)
    }
  };

  return (
    <div class="container">
      <div className="row justify-content-between align-items-center">
        <div className="col-auto align-self-start">
          <div className="d-flex align-items-center gap-2">
            <h1 class="mb-0 slackey-regular" >Vocabulary</h1>
            {flagImageUrl && (
              <img 
                src={`${API_URL}/${flagImageUrl}`} 
                alt="Game" 
                className="d-block d-md-none" 
                style={{ width: '30px'}}
              />
            )}
          </div>
        </div>
        <div className="col-auto d-none d-md-block">
             {flagImageUrl && <img src={`${API_URL}/${flagImageUrl}`} alt="Game" className="img-fluid" />}  
        </div>
      </div>  

    <div className="row mt-4">
        <div className="col-md-6">
            <div className="card rounded-0">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  {isGameActive ? (
                    <span className="custom-text-primary">Select the correct meaning for the word:</span>
                  ) : (
                    <span className="custom-text-primary">Click Start to begin</span>
                  )}
                
                  <VocabChoiceModal
                    list1Choices={listCategoryChoices}
                    list2Choices={listLevelChoices}
                    onSave={handleWordListSave}
                  />
                </div>
                {isGameActive && (
                  <VocabMultipleChoice 
                    gameKey={gameKey} 
                    onAnswerSelected={handleAnswerSelected}
                    onDataFetched={handleResultFromMultipleChoice}
                  />
                )}
                <div class="d-flex justify-content-between">
                  <button id="next-btn" 
                          className="btn btn-primary custom-next-button btn-block mt-2 w-75" 
                          onClick={nextWord}  
                          disabled={!isAnswerSelected || !isGameActive}
                          >
                            Next
                          </button>
                  <StartButton
                    onToggle={handleGameStart}
                    id="vocabStartButton"  
                    isStarted={isGameActive}
                  />
                </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
        {!isGameActive && (
          <div class="card h-200 rounded-0 custom-bg unkempt-regular text-white mb-4">
              <div class="card-body">
                <p class="card-text fs-5">Choose Word Lists for a narrower set of words.</p>
                <p class="card-text fs-5">Do as many words in a row as you like before ending.</p>
              </div>
          </div>
        )}
          <div className="card rounded-0">
              <div className="card-body">
                  <h4 className="card-title" id="results-name-2">{resultsWord}</h4>
                  {gameResult && gameResult.isEnded && gameResult.summary ? (
                    <GameSummary summary={gameResult.summary} />
                    ) : (
                    structuredResult.length > 0 && <StructuredSentence sentence={structuredResult} />
                  )}   
              </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(Vocabulary);